import { render, staticRenderFns } from "./screenFacturasNotas.vue?vue&type=template&id=061846e0&scoped=true"
import script from "./screenFacturasNotas.vue?vue&type=script&lang=js"
export * from "./screenFacturasNotas.vue?vue&type=script&lang=js"
import style0 from "./screenFacturasNotas.vue?vue&type=style&index=0&id=061846e0&prod&lang=css"
import style1 from "./screenFacturasNotas.vue?vue&type=style&index=1&id=061846e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061846e0",
  null
  
)

export default component.exports